import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Jumbotron from '../components/Jumbotron';
import { idbPromise } from '../utils/helpers';
import { CLEAR_CART } from '../utils/actions';

function Success() {
  const dispatch = useDispatch();

  // The original store used the Stripe success redirect
  // to add the order. We will do this a better way
  // and create the order in the backend before checkout.
  // (But we can use this success page to clear the cart from IndexedDB.)

  useEffect(() => {
    async function saveOrder() {
      dispatch({ type: CLEAR_CART });

      const cart = await idbPromise('cart', 'get');
      cart.forEach((item) => idbPromise('cart', 'delete', item));

      // setTimeout(() => {
      //   window.location.assign('/');
      // }, 3000);
    }

    saveOrder();
  }, [dispatch]);

  return (
    <div>
      <Jumbotron>
        <h2>Thank you for your purchase!</h2>
        <p>
          We're working on getting it shipped to you as soon as possible.
        </p>
        <p>
          You should receive a confirmation email with ways to contact us if you have any questions.
        </p>
        <div>
          <ul>
            <li><Link to="/">Go back home</Link></li>
            <li><Link to="/orderHistory">See your order history</Link></li>
          </ul>
        </div>
      </Jumbotron>
    </div>
  );
}

export default Success;
